/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecolumntype3Inputs */

const en_ticketpagecolumntype3 = /** @type {(inputs: Ticketpagecolumntype3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket type`)
};

const de_ticketpagecolumntype3 = /** @type {(inputs: Ticketpagecolumntype3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketart`)
};

/**
* | output |
* | --- |
* | "Ticket type" |
*
* @param {Ticketpagecolumntype3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecolumntype3 = /** @type {((inputs?: Ticketpagecolumntype3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecolumntype3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecolumntype3(inputs)
	return de_ticketpagecolumntype3(inputs)
});
export { ticketpagecolumntype3 as "ticketPageColumnType" }